export enum LocationsApiUrls {
  CreateEditPrivateLocation='/api/Location/CreateEditPrivateLocation',
  GetPrivateLocation='/api/Location/GetPrivateLocation',
  GetPrivateLocations = '/api/v2/Location/GetPrivateLocations',
  GetPublicLocations='/api/Location/GetPublicLocations',
  DeletePrivateLocation='/api/Location/DeletePrivateLocation',
  DeactivatePrivateLocation='/api/Location/DeactivatePrivateLocation',
  GetDawaAutoCompleteLocations = '/adresser/autocomplete',
  GetLocationsByAddressFromGLS = '/api/GlsLocation/GetLocationsByAddressFromGLS',
  AddPublicLocation ='/api/Location/CreateEditPublicLocation',
  GetLocationTypes = '/api/Location/GetLocationTypes',
  ImportLocationsFromFile = '/api/Location/ImportLocationsFromFile',
  GetLocationsImportSampleFile = '/api/Location/GetLocationsImportSampleFile',
  GetSegmentSuggestions = '/api/Location/GetSegmentSuggestions',
  GetPrivateLocationByMlsId = '/api/Location/GetPrivateLocationByMlsId',
  GetPublicLocationsForPlan ='/api/Location/GetPublicLocationsForPlan',
  GetJobWayPoints ='/api/Job/GetJobWayPoints',
  GetCountries = '/api/Country/GetCountries',
  ExportLocations = '/api/Location/ExportLocations',
}
